module.exports = __webpack_public_path__ + "img/m-wljk.f0572a97.png";